var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.455,
    height: 16,
    viewBox: "0 0 17.455 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-gallery",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2959",
    "data-name": "Group 2959",
    transform: "translate(0 7.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17400",
    "data-name": "Path 17400",
    d: "M12.693,20.1a1.451,1.451,0,0,1-.371-.048L1.076,17.041A1.468,1.468,0,0,1,.048,15.259L1.467,9.97a.364.364,0,0,1,.7.188L.751,15.445a.738.738,0,0,0,.516.894l11.241,3.01a.724.724,0,0,0,.885-.512l.568-2.1a.364.364,0,0,1,.7.189l-.567,2.1a1.453,1.453,0,0,1-1.4,1.077Z",
    transform: "translate(0 -9.701)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2960",
    "data-name": "Group 2960",
    transform: "translate(2.909 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17401",
    "data-name": "Path 17401",
    d: "M17.091,13.636H5.455A1.456,1.456,0,0,1,4,12.182V3.455A1.456,1.456,0,0,1,5.455,2H17.091a1.456,1.456,0,0,1,1.455,1.455v8.727A1.456,1.456,0,0,1,17.091,13.636ZM5.455,2.727a.728.728,0,0,0-.727.727v8.727a.728.728,0,0,0,.727.727H17.091a.728.728,0,0,0,.727-.727V3.455a.728.728,0,0,0-.727-.727Z",
    transform: "translate(-4 -2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2961",
    "data-name": "Group 2961",
    transform: "translate(5.091 4.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17402",
    "data-name": "Path 17402",
    d: "M8.455,7.909A1.455,1.455,0,1,1,9.909,6.455,1.456,1.456,0,0,1,8.455,7.909Zm0-2.182a.727.727,0,1,0,.727.727A.728.728,0,0,0,8.455,5.727Z",
    transform: "translate(-7 -5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2962",
    "data-name": "Group 2962",
    transform: "translate(2.96 6.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17403",
    "data-name": "Path 17403",
    d: "M4.434,14.372a.363.363,0,0,1-.257-.62l3.435-3.435a1.118,1.118,0,0,1,1.543,0l1.023,1.023,2.831-3.4a1.093,1.093,0,0,1,.831-.393h.008a1.09,1.09,0,0,1,.828.38l3.8,4.438a.364.364,0,0,1-.552.473L14.122,8.4a.36.36,0,0,0-.276-.127.386.386,0,0,0-.279.131l-3.086,3.7a.362.362,0,0,1-.263.13.35.35,0,0,1-.273-.106l-1.3-1.3a.374.374,0,0,0-.514,0L4.69,14.266a.362.362,0,0,1-.257.106Z",
    transform: "translate(-4.07 -7.55)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.98c0d15a910d92df2db80b83a3d265db.svg";
export { ForwardRef as ReactComponent };